module.exports = __webpack_public_path__ + "img/grayTick.e18f9ef3.svg";